var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTmb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2831_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3186_1_",
    fill: "#FFFFFF",
    d: "M47.5,33.5c-3.6,0-6.7,2.9-6.7,6.7c0,3.7,3,6.7,6.7,6.7s6.7-3,6.7-6.7 C54.1,36.5,51.1,33.5,47.5,33.5z M80.4,33.5c-3.6,0-6.7,2.9-6.7,6.7c0,3.7,2.9,6.7,6.7,6.7s6.7-3,6.7-6.7 C87.1,36.5,84.1,33.5,80.4,33.5L80.4,33.5z M41,52.4v42.1h9.2V65h0.1l10,29.5h7.2l10.1-29.6v29.6h9.3V52.4H73.5l-9.3,28.9h-0.1 l-9.8-28.9H41L41,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3194_1_",
    fill: "#FFFFFF",
    d: "M0,60.2v-7.8h34.8v7.8H22v34.2h-9.3V60.2H0L0,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3198_1_",
    fill: "#FFFFFF",
    d: "M113.1,52.4c1.9,0,3.7,0.2,5.4,0.5c1.6,0.4,3,0.9,4.1,1.7c1.1,0.8,2,1.9,2.6,3.2 c0.6,1.3,0.9,3,0.9,5c0,2.1-0.5,3.9-1.4,5.3c-0.9,1.4-2.3,2.6-4.1,3.4c2.5,0.7,4.3,2,5.6,3.9c1.2,1.8,1.8,4.1,1.8,6.8 c0,2.1-0.4,3.9-1.2,5.6c-0.8,1.5-1.9,2.8-3.2,3.8c-1.3,1-2.9,1.7-4.6,2.2c-1.7,0.5-3.5,0.7-5.4,0.7H94V52.4H113.1L113.1,52.4z  M112,69.5c1.6,0,2.9-0.4,3.9-1.2s1.5-2,1.5-3.8c0-1-0.2-1.8-0.5-2.4c-0.3-0.6-0.8-1.1-1.4-1.5s-1.2-0.6-2-0.7 c-0.7-0.1-1.5-0.2-2.3-0.2h-8.5v9.8h9.3V69.5z M112.5,87.3c0.9,0,1.7-0.1,2.5-0.3c0.8-0.2,1.5-0.5,2.1-0.9s1.1-1,1.5-1.7 s0.5-1.6,0.5-2.7c0-2.1-0.6-3.7-1.8-4.6c-1.2-0.9-2.7-1.4-4.6-1.4h-9.8v11.6h9.6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmb);
export default __webpack_public_path__ + "static/media/tmb.c6a3cd3fc97dfa4515a7bee86153d4db.svg";
export { ForwardRef as ReactComponent };